import { createApp } from 'vue';

// Dynamically import modules
const modules = {
    Product: () => import('../vue/modules/Product.vue'),
    Menu: () => import('../vue/modules/Menu.vue'),
    Privacy: () => import('../vue/modules/Privacy.vue'),
};

const moduleElements = document.querySelectorAll('[data-module]');

moduleElements.forEach((element) => {
    const moduleName = element.getAttribute('data-module');
    const moduleProps = JSON.parse(element.getAttribute('data-props') || '{}');

    // Dynamically load and mount the Vue component
    if (moduleName && modules[moduleName]) {
        modules[moduleName]().then((module) => {
            const app = createApp(module.default, moduleProps);
            app.mount(element);
        });
    } else {
        console.error(`No Vue component found for module: ${moduleName}`);
    }
});
